import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { FIELD_LENGTHS } from '../../../shared/field-lengths';
import { KiMarkComponent } from '../ki-mark/ki-mark.component';

let naechsteNr = 0;

/**
 * Dialog „Testfälle vorschlagen“ (page-ki.jsx:243-263). Eigenbau statt `lib-modal`: dessen Kopf hat keinen Platz
 * für KiMark, und den Untertitel übersetzt er als Schlüssel statt „{AnfID} · {Titel}“ wörtlich zu zeigen. Der
 * Aufrufer blendet ihn per {@code @if} ein; Esc und Overlay brechen ab.
 */
@Component({
  selector: 'app-ki-testfall-vorschlag-dialog',
  imports: [A11yModule, KiMarkComponent, MatButtonModule, TranslatePipe],
  templateUrl: './ki-testfall-vorschlag-dialog.component.html',
  styleUrl: './ki-testfall-vorschlag-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiTestfallVorschlagDialogComponent {
  /** „{AnfID} · {Titel}“ unter dem Titel. */
  readonly kontext = input.required<string>();
  /** Text des Akzeptanzkriteriums, wenn der Dialog aus einer Lücke von „Abdeckung prüfen“ kommt. */
  readonly kriterium = input<string | null>(null);
  /** Der getrimmte Hinweis, leer ohne Hinweis. */
  readonly erzeugen = output<string>();
  readonly abgebrochen = output<void>();
  /** Bleibt beim Aufrufer, damit der Hinweis beim nächsten Öffnen wieder dasteht (page-ki.jsx:206). */
  readonly hinweis = model('');

  protected readonly maxLaenge = FIELD_LENGTHS.KI_HINWEIS_MAX;
  protected readonly titelId = `ki-vorschlag-titel-${++naechsteNr}`;
  protected readonly hinweisId = `ki-vorschlag-hinweis-${naechsteNr}`;
  /** `maxlength` greift nur beim Tippen; ein per Skript gesetzter Wert kann länger sein. */
  protected readonly zuLang = computed(() => this.hinweis().length > this.maxLaenge);

  protected eingabe(event: Event): void {
    this.hinweis.set((event.target as HTMLInputElement).value);
  }

  protected absenden(): void {
    if (!this.zuLang()) this.erzeugen.emit(this.hinweis().trim());
  }

  /** Der Dialog liegt im Formular der Anforderung: Enter darf es nicht absenden. */
  protected enter(event: Event): void {
    event.preventDefault();
    this.absenden();
  }

  protected escape(event: Event): void {
    event.stopPropagation();
    this.abgebrochen.emit();
  }
}
